<template>
    <svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M28.9361 39.1026H3.3186C2.27061 39.1026 1.42102 38.2519 1.42102 37.2024V4.79379C1.42102 3.7443 2.27061 2.89355 3.3186 2.89355H28.9361C29.9841 2.89355 30.8337 3.7443 30.8337 4.79379V37.2025C30.8337 38.2519 29.9841 39.1026 28.9361 39.1026Z"
            fill="white"
        />
        <path
            d="M5.20981 9.8505V2.93604H3.31835C2.27037 2.93604 1.42078 3.74414 1.42078 4.79354V37.2022C1.42078 38.2516 2.27037 39.1185 3.31835 39.1185H28.9359C29.9839 39.1185 30.88 38.2516 30.88 37.2022V35.5192C16.7028 35.5192 5.20981 24.0269 5.20981 9.8505Z"
            fill="#E6E7E8"
        />
        <path
            d="M22.9448 40.5232H3.3185C1.48865 40.5232 0 39.0335 0 37.2023V4.79364C0 2.96246 1.48865 1.47266 3.3185 1.47266H6.53275V4.31423H3.3185C3.05557 4.31423 2.84175 4.52929 2.84175 4.79364V37.2023C2.84175 37.4667 3.05566 37.6817 3.3185 37.6817H22.9448V40.5232Z"
            fill="#FD6144"
        />
        <path
            d="M32.2546 24.1221H29.4128V4.79364C29.4128 4.52929 29.1989 4.31423 28.9361 4.31423H25.9553V1.47266H28.9361C30.7659 1.47266 32.2546 2.96246 32.2546 4.79364V24.1221Z"
            fill="#FD6144"
        />
        <path
            d="M21.6476 5.70062H10.6069C9.72564 5.70062 9.01123 4.98621 9.01123 4.10497V1.59564C9.01123 0.714406 9.72564 0 10.6069 0H21.6476C22.5288 0 23.2432 0.714406 23.2432 1.59564V4.10497C23.2432 4.98621 22.5288 5.70062 21.6476 5.70062Z"
            fill="#5021D1"
        />
        <path d="M16.6042 21.729H26.8623V24.5706H16.6042V21.729Z" fill="#FD6144" />
        <path d="M16.6042 13.1782H26.8623V16.0198H16.6042V13.1782Z" fill="#FD6144" />
        <path d="M16.6042 30.2798H21.4631V33.1214H16.6042V30.2798Z" fill="#FD6144" />
        <path
            d="M25.0029 32.5411C24.2891 36.672 27.0579 40.6228 31.1871 41.3655C35.3164 42.1082 39.2425 39.3616 39.9563 35.2307C40.6701 31.0999 37.9013 27.1491 33.772 26.4064C29.6427 25.6637 25.7167 28.4102 25.0029 32.5411Z"
            fill="#5021D1"
        />
        <path
            d="M30.6653 36.7908L28.0945 34.1736L30.1198 32.1782L31.6741 33.7565L34.7928 30.5625L36.8258 32.5475L32.6945 36.787C32.4286 37.0593 31.5116 37.6034 30.6653 36.7908Z"
            fill="white"
        />
        <path
            d="M7.59183 34.4975L4.83252 31.4923L6.92671 29.5733L8.6392 31.4414L12.7098 27.0059L14.8033 28.9273L9.68567 34.4978C9.41663 34.7909 8.42901 35.2827 7.59183 34.4975Z"
            fill="#FD6144"
        />
        <path
            d="M7.59183 25.9731L4.83252 22.9679L6.92671 21.0489L8.6392 22.917L12.7098 18.4814L14.8033 20.4029L9.68567 25.9734C9.41663 26.2664 8.42901 26.7582 7.59183 25.9731Z"
            fill="#FD6144"
        />
        <path
            d="M7.59183 17.3535L4.83252 14.3482L6.92671 12.4293L8.6392 14.2974L12.7098 9.86182L14.8033 11.7832L9.68567 17.3537C9.41663 17.6469 8.42901 18.1386 7.59183 17.3535Z"
            fill="#FD6144"
        />
    </svg>
</template>
<script>
export default {
    name: "TaskManagment",
};
</script>
